require('./src/blocks.validation.module');
require('./src/libs/ng-fluent-validation');
require('./src/components/validation.helper');
require('./src/components/validation.provider');
require('./src/config/validation.config');
require('./src/directives/validation.directive');
require('./src/templates/validation.template');
require('./src/css/blocks.validations.styles.scss');